import React, {useState} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';
import moment from 'moment/moment';
import {Table} from 'ui';
import {useT} from 'hooks/Locale/useT';
import {LogDetailsModal} from 'components/Modals';
import {EyeOutlined} from '@ant-design/icons';

interface EventsTabProps {
    userTypeId: number;
}

const EventsTab: React.FC<EventsTabProps> = ({userTypeId}) => {
    const [showLogDetails, setShowLogDetails] = useState(false);
    const [logDetailsContent, setLogDetailsContent] = useState<any>({});
    // Keyed by user_uuid, filled from the events response's `users` map
    // (see ui/Table onLoadFunction).
    const [initiators, setInitiators] = useState<Record<string, any>>({});

    const intl = useIntl();
    const t = useT();
    const [reload, setReload] = useState(false);

    const parseEventDiff = (oldValues: any, newValues: any) => {
        return {
            old: JSON.parse(oldValues),
            ...JSON.parse(newValues)
        }
    }

    const columns = [
        {
            title: intl.formatMessage({id: 'general.event_object_type'}),
            dataIndex: 'event_object_type'
        },
        {
            title: intl.formatMessage({id: 'general.event_initiator'}),
            render: (_: string, record: any) => {
                const role = record.event_initiator_type || '';
                if (role === 'SYSTEM') {
                    const source = record.event_initiator_source;
                    return source
                        ? `${t('system.audit.system_process')}: ${source}`
                        : t('system.audit.system_process');
                }
                const user = initiators[record.user_uuid];
                const name = user ? [user.name, user.surname].filter(Boolean).join(' ') : '';
                const email = user?.email || '';
                if (!name && !email) {
                    return role;
                }
                return `${[name, email && `(${email})`].filter(Boolean).join(' ')} (${role})`;
            }
        },
        {
            title: intl.formatMessage({id: 'general.created_at'}),
            render: (_: string, record: any) => moment(record.created_at).format('DD.MM.YYYY HH:mm:ss')
        },
        {
            title: intl.formatMessage({id: 'system.audit.attributes'}),
            key: 'attributes',
            render: (_: string, record: any) => {
                return <p
                    className='description-icon'
                    onClick={() => {
                        setShowLogDetails(true);
                        setLogDetailsContent(parseEventDiff(record.event_data_old, record.event_data_new))
                    }}
                    >
                    <FormattedMessage id={'general.show'}/> <EyeOutlined />
                </p>
            }
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                url={`api/v1/customer-users/${userTypeId}/user-events`}
                setReload={setReload}
                rowSelection={false}
                reload={reload}
                rowKey={'id'}
                scroll={{x: 800}}
                onLoadFunction={(resp: any) => setInitiators(resp?.users || {})}
            />
            <LogDetailsModal
                visible={showLogDetails}
                onCancel={setShowLogDetails}
                content={logDetailsContent}
                excludeKeys={['student_user_type_uuid', 'student_user_type']}
            />
        </>
    );
};

export default EventsTab;
